const PLANETS = ["Sun", "Moon", "Mars", "Mercury", "Jupiter", "Venus", "Saturn", "Rahu", "Ketu"] as const;

/** "Sun, Venus and Mercury": the planets the reasons open with, in their order. */
export function planetsIn(reasons: readonly string[]): string {
  const named = reasons
    .map((r) => PLANETS.find((p) => r.startsWith(`${p} `)))
    .filter((p): p is (typeof PLANETS)[number] => p !== undefined);
  const unique = [...new Set(named)];
  if (unique.length <= 1) return unique[0] ?? "";
  return `${unique.slice(0, -1).join(", ")} and ${unique[unique.length - 1]}`;
}
